export default __webpack_public_path__ + "src/dataset/galleries-d3fc-10cb66.txt";